import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./project.css";
import { FaProjectDiagram, FaSmile, FaUsers, FaAward } from "react-icons/fa";

function Counter({ target, suffix = '' }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const increment = target / 100;
    const interval = setInterval(() => {
      start += increment;
      if (start >= target) {
        clearInterval(interval);
        setCount(target);
      } else {
        setCount(Math.floor(start));
      }
    }, 20);
    return () => clearInterval(interval);
  }, [target]);

  return <span className="counter">{count}{suffix}</span>;
}

function Project() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const stats = [
    {
      label: "Total Projects",
      target: 205,
      icon: <FaProjectDiagram size={40} color="#66bb6a" />,
    },
    {
      label: "Happy Clients",
      target: 162,
      icon: <FaSmile size={40} color="#66bb6a" />,
    },
    {
      label: "Active Members",
      target: 84,
      icon: <FaUsers size={40} color="#66bb6a" />,
    },
    {
      label: "Won Awards",
      target: 10,
      icon: <FaAward size={40} color="#66bb6a" />,
    },
  ];

  return (
    <div className="fact-counter-wrapper padding ptb-xs-40 mt-4">
      <div className="container text-center">
        <div className="row">
          {stats.map((item, index) => (
            <div
              className="col-lg-3 col-md-6 mb-sm-30 mb-xs-30"
              key={index}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="single-fact">
                <div className="icon-boxed mb-2" >{item.icon}</div>
                <Counter target={item.target} suffix="+"/>
                <p style={{ fontFamily:"Lora"}}>{item.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Project;
